// Frontend mirror of study/assets/brief-accident-v2/questionnaire.json.
// Keep this aligned with the live study questionnaire.

export const FORM_SCHEMA = [
  {
    id: "description_of_accident",
    structure_type: "regular",
    question_text: "Briefly describe what happened.",
    type: "multiline_text",
  },
  {
    id: "date_of_accident",
    structure_type: "regular",
    question_text: "What date did the accident happen?",
    type: "date",
  },
  {
    id: "time_of_accident",
    structure_type: "regular",
    question_text: "About what time did it happen?",
    type: "time",
  },
  {
    id: "location_of_accident",
    structure_type: "regular",
    question_text: "Where did it happen?",
    type: "text",
  },
  {
    id: "road_conditions",
    structure_type: "regular",
    question_text: "What were the road or weather conditions?",
    type: "text",
  },
  {
    id: "number_of_vehicles_involved",
    structure_type: "regular",
    question_text: "How many vehicles were involved?",
    type: "number",
  },
  {
    id: "vehicles",
    structure_type: "repeat_group",
    label: "Vehicle details",
    repeat: {
      mode: "from_slot",
      from_slot: "number_of_vehicles_involved",
      item_label: "Vehicle {{index}}",
    },
    fields: [
      {
        id: "role",
        structure_type: "regular",
        question_text: "Whose vehicle is this, or what role did it play?",
        type: "text",
      },
      {
        id: "vehicle_description",
        structure_type: "regular",
        question_text: "What is the vehicle description, including plate if known?",
        type: "text",
      },
      {
        id: "damage_description",
        structure_type: "regular",
        question_text: "What damage did this vehicle have, and could it be driven afterward?",
        type: "text",
      },
    ],
  },
  {
    id: "property_damage",
    structure_type: "regular",
    question_text: "Was anything besides the vehicles damaged?",
    type: "text",
  },
  {
    id: "injuries",
    structure_type: "regular",
    question_text: "Was anyone hurt?",
    type: "text",
  },
  {
    id: "witnesses",
    structure_type: "regular",
    question_text: "Were there any witnesses or contact details?",
    type: "text",
  },
];

export const MOCK_FINAL_RECORD = {
  description_of_accident:
    "I was in the right lane preparing to turn right when a red two-door car moved into my lane from the left. I braked and hit a traffic-light pole.",
  date_of_accident: "2026-07-02",
  time_of_accident: "14:35",
  location_of_accident: "Main St and Oak Ave, Springfield",
  road_conditions: "Wet road after light rain had just stopped",
  number_of_vehicles_involved: 2,
  "vehicles[1].role": "My vehicle",
  "vehicles[1].vehicle_description": "My blue Toyota Corolla, plate AB12 CDE",
  "vehicles[1].damage_description": "My vehicle had a dented front-right bumper and scratches on the left side; it was still drivable and was not towed",
  "vehicles[2].role": "The other car that moved from the left lane into my lane",
  "vehicles[2].vehicle_description": "The other vehicle was a red two-door car; I did not know its plate",
  "vehicles[2].damage_description": "The other vehicle had scratches on its right side and was able to drive away",
  property_damage: "Traffic-light pole was bent",
  injuries: "No one was hurt",
  witnesses: "Sam Lee, 555-0100",
};
